// axios
import axios from "axios";
// const baseURL = "https://attila.mbsi.com.ph";
// const baseURL = "https://haskoning.mbsi.com.ph";
// const baseURL = "https://sandviktamrock.mbsi.com.ph";
const baseURL = "https://evaair.mbsi.com.ph";
// const baseURL = "https://terrysa.mbsi.com.ph";
// const baseURL = "https://upc.mbsi.com.ph";
// const baseURL = "https://havaianas-config.mbsi.com.ph";
export default axios.create({
  baseURL: baseURL,
  // You can add your headers here
});
